import OccurrenceTypeIndex from '../views/OccurrenceType/Index'

let routes = {
    path: '/occurrence-types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '',
            name: 'occurrence-types',
            component: OccurrenceTypeIndex,
        },
    ],
}

export default routes
